import { isFeaturedVisualPrompt } from '@/constants/visualPrompts/featuredPromptIds';
import { getFeaturedOverride } from '@/utils/visualPrompts/featuredVisualPromptStorage';
import type { VisualPromptDefinition } from '@/types/visualPrompts/visualPrompt.types';

export const resolveIsFeatured = (
  definition: VisualPromptDefinition,
): boolean => {
  const override = getFeaturedOverride(definition.id);
  if (override !== undefined) {
    return override;
  }
  if (definition.isCustom) {
    return definition.isFeatured ?? false;
  }
  return definition.isFeatured ?? isFeaturedVisualPrompt(definition.id);
};

export const applyFeaturedState = (
  definition: VisualPromptDefinition,
): VisualPromptDefinition => ({
  ...definition,
  isFeatured: resolveIsFeatured(definition),
});

export const applyFeaturedStateToList = (
  definitions: VisualPromptDefinition[],
): VisualPromptDefinition[] =>
  definitions.map(applyFeaturedState);
